import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Tag from 'antd/lib/tag';

import { IconTrash } from '@tabler/icons-react';

import styles from './selected-sites-card.module.css';

export default function SelectedSitesCard({ selectedSites, clearSelectedSites, handleSiteRemove }) {
    return (
        <Box className={styles.selectedSitesSection}>
            <div className={styles.sectionHeader}>
              <div className={styles.headerLeft}>
                <Typography variant="h6">Selected Sites</Typography>
                <Typography variant="caption" color="textSecondary">
                  {selectedSites.length} sites selected
                </Typography>
              </div>
              {selectedSites.length > 0 && (
                <Button
                  size="small"
                  onClick={clearSelectedSites}
                  startIcon={<IconTrash size={16} />}
                  className={styles.clearButton}
                >
                  Clear All
                </Button>
              )}
            </div>
            <div className={styles.selectedSites}>
              {selectedSites.map(site => (
                <Tag
                  key={site.site_id}
                  closable
                  onClose={() => handleSiteRemove(site.site_id)}
                  className={styles.siteTag}
                >
                  {site.site_name}
                </Tag>
              ))}
              {selectedSites.length === 0 && (
                <Typography variant="body2" color="textSecondary" className={styles.noSites}>
                  No sites selected
                </Typography>
              )}
            </div>
        </Box>
    )
}